export const FREE_ROAM_MODE = "free_roam"
export const PAINT_MODE = "paint"
export const RUBBER_MODE = "rubber"